import React, { useMemo } from "react";
import { Typography, Box } from "@mui/material";
import { TouchApp } from "@mui/icons-material";

import { INVITATION_OCCASION, Invitations } from "../../../../../store/services/invitations/dto/invitations.dto";
import { PalaceDoorsEntranceWrapper } from "./styles";
import { LANG_AR, LANG_EN, RTL } from "../../../../../Components/Templates/WeddingTemplates/constants";
import langEN from "../../../../../Components/Templates/WeddingTemplates/lang.EN.json";
import langAR from "../../../../../Components/Templates/WeddingTemplates/lang.AR.json";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

const Leaf = ({ side }: { side: "left" | "right" }) => (
	<div className={`leaf ${side}`}>
		<div className={"panel panel_top"} />
		<div className={"panel panel_bottom"} />
		<div className={"studs"} />
		<div className={"handle"} />
	</div>
);

const PalaceDoorsEntrance = ({
	isOpened,
	setIsOpened,
	selectedInvitation,
	colorMatrix,
	preview
}: {
	isOpened: boolean;
	setIsOpened: React.Dispatch<React.SetStateAction<boolean>>;
	selectedInvitation: Invitations;
	colorMatrix: TemplateColorObject;
	preview?: boolean;
}) => {
	const lang = selectedInvitation?.language === LANG_EN ? langEN : langAR;

	const invitationType = useMemo(() => {
		if (!selectedInvitation) return;
		switch (selectedInvitation?.occasion) {
			case INVITATION_OCCASION.KATB_KTAB: {
				return lang.the_katb_ktab_of;
			}
			case INVITATION_OCCASION.ENGAGEMENT: {
				return lang.the_engagement_of;
			}
			default: {
				return lang.the_wedding_of;
			}
		}
	}, [selectedInvitation]);

	return (
		<PalaceDoorsEntranceWrapper
			className={`${isOpened ? "hide opened" : "show"} ${preview ? "preview" : ""}`}
			onClick={() => setIsOpened(true)}
			colormatrix={colorMatrix}
		>
			<div className={"doorway"}>
				<div className={"light"} />
				<div className={`couples_banner ${selectedInvitation?.language === LANG_AR && RTL}`}>
					<Typography className={"wedding_of"}>{invitationType}</Typography>
					<Box display={"flex"} justifyContent={"center"} flexWrap={"wrap"} gap={1}>
						<Typography className={"couples groom"}>{selectedInvitation?.groom_name}</Typography>
						<Typography className={"couples and"}> {lang.and} </Typography>
						<Typography className={"couples bride"}> {selectedInvitation?.bride_name} </Typography>
					</Box>
				</div>
				<div className={"doors"}>
					<Leaf side={"left"} />
					<Leaf side={"right"} />
				</div>
			</div>

			<Box className={"tab_continue_container"} display={"flex"} flexDirection={"column"}>
				<Box
					className={`tab_continue ${isOpened ? "animate__animated animate__fadeOut" : "animate__animated animate__headShake animate__delay-2s animate__infinite"}`}
				>
					<TouchApp />
				</Box>
				<Typography className={`tab_continue_text ${isOpened ? "animate__animated animate__fadeOut" : ""}`}>
					{lang.TAP_TO_OPEN_DOORS}
				</Typography>
			</Box>
		</PalaceDoorsEntranceWrapper>
	);
};

export default PalaceDoorsEntrance;
